
/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import en from './en';

export default {
  translation: {
    ...en.translation,
    header_title: "Constantina",
    nav_shopping_assistant: "Assistente allo Shopping",
    nav_assistant_short: "Assistente",
    nav_style_lab: "Style Lab",
    nav_studio: "Studio di Stile",
    nav_tryon: "Prova Virtuale",
    nav_actions_title: "Azioni",
    portfolio_instagram_connect_title: 'Connettiti su Instagram',
    "shoppingAssistant_title": "Assistente allo Shopping",
    "shoppingAssistant_subtitle": "Potenziato dall'IA",
    "shoppingAssistant_greeting": "Ciao! Sono il tuo assistente allo shopping IA. Come posso aiutarti oggi? Puoi chiedermi di trovare prodotti, controllare lo stato del tuo ordine o aiutarti con i resi.",
    "shoppingAssistant_error_connection": "Mi dispiace, ho problemi di connessione al momento.",
    "shoppingAssistant_history_cleared": "Cronologia cancellata. Come posso aiutarti oggi?",
    "shoppingAssistant_clear_history": "Cancella conversazione",
    "shoppingAssistant_close": "Chiudi assistente",
    "shoppingAssistant_role_assistant": "Assistente",
    "shoppingAssistant_copy_caption": "Copia didascalia",
    "shoppingAssistant_social_media_title": "Didascalie social generate dall'IA",
    "shoppingAssistant_save_to_advice": "Salva nei Consigli",
    "shoppingAssistant_select_slot": "Seleziona",
    "shoppingAssistant_thinking": "L'assistente sta pensando...",
    "shoppingAssistant_input_placeholder": "Cerca prodotti, traccia ordini...",
    "shoppingAssistant_send_aria": "Invia messaggio",
    "shoppingAssistant_suggest_summer_dresses": "Abiti estivi",
    "shoppingAssistant_suggest_track_order": "Traccia ordine",
    "shoppingAssistant_suggest_return_policy": "Politica di reso",
    "shoppingAssistant_response_products": "Ho trovato alcuni {{category}} che potrebbero piacerti:",
    "shoppingAssistant_response_order_status": "Ecco lo stato del tuo ordine {{orderId}} :",
    "shoppingAssistant_response_order_not_found": "Non sono riuscito a trovare quell'ordine. Per favore, controlla l'ID dell'ordine e riprova.",
    "shoppingAssistant_response_return_policy": "La nostra politica di reso ti consente di restituire gli articoli entro 30 giorni dalla consegna. Gli articoli devono essere non indossati e nella confezione originale. Vorresti avviare un reso per un ordine specifico?",
    "shoppingAssistant_response_social_media": "Ho preparato alcune didascalie social personalizzate basate sul tuo look attuale! Quale preferisci?",
    "shoppingAssistant_response_social_no_garment": "Mi piacerebbe aiutarti con un post ! Potresti prima selezionare un capo nello spogliatoio così ho qualcosa su cui scrivere?",
    "shoppingAssistant_response_booking": "Posso sicuramente aiutarti a prenotare una sessione di styling professionale. Quando avevi in mente?",
    "shoppingAssistant_service_styling_consultation": "Consulenza di Styling Personale",
    "shoppingAssistant_response_wardrobe_matches": "Ho trovato alcuni abbinamenti nel tuo armadio, più alcuni pezzi dal nostro catalogo per completare il look:",
    "shoppingAssistant_response_retail_matches": "In base alle tue preferenze di stile, ho trovato questi articoli per te:",
    "shoppingAssistant_response_greeting": "Ciao! Sono il tuo assistente personale per lo stile e lo shopping. Posso aiutarti a trovare prodotti (nel nostro negozio o nel tuo armadio), creare post sui social per i tuoi look o prenotare una consulenza. Come posso aiutarti oggi?",
    "shoppingAssistant_response_fallback": "Sono qui per aiutarti con il tuo stile! Puoi chiedermi di trovare prodotti, creare post social o darti consigli di moda.",
    "shoppingAssistant_order_status_label": "Stato dell'ordine",
    "shoppingAssistant_order_id_label": "ID ordine",
    "shoppingAssistant_order_date_label": "Data",
    "shoppingAssistant_order_items_label": "Articoli",
    "shoppingAssistant_order_total_label": "Importo totale",
    "shoppingAssistant_order_est_delivery_label": "Consegna prevista",
    "shoppingAssistant_order_track_cta": "Traccia pacco",
    "shoppingAssistant_order_status_shipped": "Spedito",
    "shoppingAssistant_order_status_delivered": "Consegnato",
    "shoppingAssistant_order_status_processing": "In lavorazione",
    "shoppingAssistant_product_in_wardrobe": "Nel tuo armadio",
    "shoppingAssistant_product_low_stock": "Disponibilità limitata",
    "shoppingAssistant_product_price_wardrobe": "ARMADIO",
    "shoppingAssistant_product_add_to_basket": "Aggiungi al carrello",
    "shoppingAssistant_product_owned": "Posseduto",
    "shoppingAssistant_product_already_in_wardrobe": "Già nel tuo armadio",
    portfolio_instagram_connect_desc: 'Segui le nostre storie di stile quotidiane, i contenuti dietro le quinte e le funzionalità della community.',
    common_connect: 'Connetti',
    voucher_title: "Buoni Regalo",
    voucher_cta: "Acquista Buono",
    voucher_tagline: "Regala lo stile.",
    portfolio_feature_color_analysis: "Armocromia",
    portfolio_feature_all_complete_features: "Tutte le caratteristiche del pacchetto completo",
    trends_page_subtitle: "Cosa c'è di Nuovo",
    trends_page_title: "Tendenze Moda",
    trends_page_description: "Scopri le ultime tendenze moda selezionate per la tua generazione.",
    trends_filter_all: "Tutte le Generazioni",
    portfolio_video_views: 'Visualizzazioni',
    colorStudio_title: "Studio di analisi del colore",
    feature_locked_guest: "Funzione bloccata (Ospite)",
    upgrade_membership: "Aggiorna abbonamento",
    shoppingAssistant_membership_locked: "L'assistente agli acquisti è disponibile per i nostri membri Premium e Advanced.",
    view_plans: "Visualizza piani",
    colorStudio_premium_required: "Sblocca l'analisi del colore stagionale personalizzata e i consigli sulla palette. Disponibile per i membri Premium e Advanced.",
    colorStudio_subtitle: "Scopri il potere del colore. Individua le sfumature che si armonizzano con il tuo incarnato, capelli e occhi unici.",
    colorStudio_powerColors_desc: "I colori chiave che esaltano la tua bellezza.",
    colorAnalysis_title: "Analisi del colore",
    colorAnalysis_confirm_new: "Hai già un'analisi del colore nel tuo profilo. Vuoi effettuarne una nuova basata sul rilevamento dell'immagine?",
    colorAnalysis_analyze_new: "Analizza una nuova foto",
    colorAnalysis_analyzing: "Analisi dei tuoi colori in corso...",
    colorAnalysis_analyzing_subtext: "Determinazione della stagione, del tono della pelle e del contrasto.",
    colorAnalysis_upload_title: "Carica una foto",
    colorAnalysis_upload_btn: "Seleziona un'immagine",
    colorAnalysis_season_label: "La tua stagione",
    colorAnalysis_characteristic_skin: "Pelle:",
    colorAnalysis_characteristic_contrast: "Contrasto:",
    colorAnalysis_characteristic_eyes: "Occhi:",
    colorAnalysis_characteristic_hair: "Capelli:",
    colorAnalysis_powerColors: "Colori potenti",
    colorAnalysis_neutrals: "Toni neutri",
    colorAnalysis_avoid: "Colori da evitare",
    colorAnalysis_advice_hair_makeup: "Capelli e trucco",
    colorAnalysis_advice_clothing: "Consigli di abbigliamento",
    colorAnalysis_error: "Analisi non riuscita.",
    colorAnalysis_no_result_title: "Nessuna analisi del colore ancora",
    colorAnalysis_no_result_desc: "Carica una foto o seleziona un outfit salvato per scoprire la tua stagione di colori e la tua palette personale.",
    colorAnalysis_start_button: "Inizia la mia analisi del colore",
    colorAnalysis_label_hair: "Capelli",
    colorAnalysis_label_makeup: "Trucco",
    colorAnalysis_label_jewelry: "Gioielli",
    colorAnalysis_saved_to_profile: "Salvato nel profilo",
    colorAnalysis_save_to_profile: "Salva analisi nel profilo",
    colorAnalysis_apply_palette_title: "Applica palette all'outfit",
    colorAnalysis_apply_palette_hint: "Clicca su un colore per applicarlo",
    colorAnalysis_apply_color_aria: "Applica colore {{color}}",
    colorAnalysis_target_item: "Articolo target",
    colorAnalysis_powerColors_desc: "Questi colori essenziali proiettano la tua massima sicurezza e vitalità.",
    colorAnalysis_admin_mode: "ADMIN",
    colorAnalysis_admin_analyzing: "Analisi del set curato in corso...",
    colorAnalysis_admin_label: "Modalità Admin:",
    colorAnalysis_admin_desc: "Carica una foto dettagliata dell'outfit per estrarre gli articoli e creare un set Shop the Look.",
    colorAnalysis_admin_save_set: "Salva nei set curati",
    colorAnalysis_admin_shop_now: "Link Shop Now",
    colorAnalysis_admin_failed_analyze: "Analisi del set fallita",
    colorAnalysis_admin_failed_save: "Salvataggio fallito.",
    colorAnalysis_admin_curated_saved: "Set curato e articoli salvati localmente! (Aggiorna per vedere nel guardaroba)",
    colorAnalysis_characteristic_skinTone: "Tonalità della pelle:",
    colorAnalysis_characteristic_hairColor: "Colore dei capelli:",
    colorAnalysis_characteristic_eyeColor: "Colore degli occhi:",
    colorAnalysis_characteristic_faceShape: "Forma del viso:",
    colorAnalysis_characteristic_bodySize: "Corporatura:",
    colorAnalysis_save_to_advice_title: "Analisi del colore - {{season}}",
    colorAnalysis_unknown: "Sconosciuto",
    colorAnalysis_saved_to_profile_success: "Salvato nel profilo",
    myStylesPage_savedColorAnalysis_title: "Le mie analisi della palette di colori",
    myStylesPage_savedColorAnalysis_desc: "La tua cronologia delle scoperte di colori personali e stagionalità.",
    myStylesPage_noSavedAnalysis: "Nessun risultato di analisi del colore salvato ancora.",
    rss_source_constantina: "Constantina",

    "homePage_vision_time_title": "Mattinate senza sforzo",
    "homePage_vision_time_desc": "Elimina la fatica decisionale. La nostra IA pianifica i tuoi outfit settimanali in pochi secondi, così puoi concentrarti sull'essenziale.",
    "homePage_vision_quality_title": "Qualità e Precisione Svizzera",
    "homePage_vision_quality_desc": "Fondata in Svizzera, portiamo standard senza compromessi di qualità e sicurezza dei dati nel tuo guardaroba digitale.",
    "homePage_vision_digitalTwin_title": "Eredità del Design Italiano",
    "homePage_vision_digitalTwin_desc": "Intrisa dell'anima della moda milanese, la nostra IA è addestrata sui principi dell'eleganza e della sartoria italiana.",

    "home_how_it_works_title": "Il tuo percorso verso l'Eccellenza Svizzera e lo Stile Italiano",
    "home_how_it_works_step1_title": "1. Analisi Visiva di Precisione",
    "home_how_it_works_step1_desc": "Inizia con un'analisi visiva che cattura la tua aura unica. La nostra IA di ingegneria svizzera mappa le tue proporzioni con precisione chirurgica.",
    "home_how_it_works_step2_title": "2. Intuizioni Italiane Curate",
    "home_how_it_works_step2_desc": "Esplora raccomandazioni curate con un occhio italiano per i dettagli, assicurando che ogni combinazione emani 'Sprezzatura' e fiducia.",
    "home_how_it_works_step3_title": "3. Curatela Esperta e Maestria",
    "home_how_it_works_step3_desc": "Il tocco finale della maestria umana. Prenota con i nostri stylist esperti per finalizzare la tua trasformazione con cura personale.",

    stylingAdvisorPage_startChat: 'Inizia Chat',
    myStylesPage_sourceOutfit: 'Fonte Outfit',
    myStylesPage_social_linkedin: 'LinkedIn',
    myStylesPage_social_twitter: 'Twitter',
    myStylesPage_social_instagram: 'Instagram',
    blog_post_not_found: 'Post non trovato.',
    common_pdf: 'PDF',
    resource_category_style: 'Stile',
    resource_category_color: 'Colore',
    resource_category_business: 'Business',

    "rss_1_title": "Guida alle tendenze di Vogue 2024",
    "rss_1_snippet": "Scopri i pezzi chiave che definiscono l'estetica di questa stagione.",
    "rss_2_title": "Highlights Street Style",
    "rss_2_snippet": "I migliori look catturati nelle strade di Milano e Parigi.",
    "rss_3_title": "Il Futuro delle Calzature",
    "rss_3_snippet": "Le ultime uscite e collaborazioni che definiscono la scena sneaker.",
    "rss_4_title": "Lusso Sostenibile",
    "rss_4_snippet": "Come i marchi di alta gamma stanno adottando materiali eco-friendly.",
    "rss_5_title": "Bellezza Decodificata",
    "rss_5_snippet": "Le tendenze beauty più in voga direttamente dalle passerelle.",

    "campaign_new_year_title": "Nuovo Anno, Nuovo Stile",
    "campaign_new_year_desc": "Aggiorna il tuo look per il nuovo anno.",
    "campaign_event_glamour_title": "Glamour Eventi",
    "campaign_event_glamour_desc": "Splendi al tuo prossimo grande evento.",
    "campaign_executive_title": "Presenza Esecutiva",
    "campaign_executive_desc": "Domina la stanza con un'immagine professionale potente.",
    "campaign_color_title": "Palette Perfetta",
    "campaign_color_desc": "Scopri i colori che ti fanno brillare.",
    "campaign_shopping_title": "Shopping Intelligente",
    "campaign_shopping_desc": "Pezzi curati che si adattano perfettamente al tuo stile di vita.",
    "campaign_style_transformation_title": "Trasformazione Totale",
    "campaign_style_transformation_desc": "Reinventati con il nostro workshop di styling completo.",
    "campaign_summer_title": "Stile Radioso d'Estate",
    "campaign_summer_desc": "Abbraccia il sole con palette vivaci e silhouette traspiranti.",
    "campaign_easter_title": "Rinnovo di Pasqua",
    "campaign_easter_desc": "Rinfresca il tuo look con eleganza pastello e texture stagionali.",

    "campaign_soft_power_title": "Rivoluzione Soft Power",
    "campaign_soft_power_desc": "Abbraccia l'estetica executive del 2026: spalle arrotondate, tailleur pastello e sartoria fluida.",
    "campaign_sportif_chic_title": "Sportif Chic & Wellness",
    "campaign_sportif_chic_desc": "L'abbigliamento sportivo elevato incontra il lusso quotidiano. Tessuti tecnici con tocchi femminili.",
    "campaign_badge_trending": "Di Tendenza",

    "campaign_badge_limited_time": "Tempo Limitato",
    "campaign_badge_events": "Speciale Stagione",
    "campaign_badge_professional": "Professionale",
    "campaign_badge_bestseller": "Best Seller",
    "campaign_badge_seasonal": "Stagionale",
    "campaign_badge_exclusive": "Esclusivo",
    "campaign_included_services": "Servizi Inclusi",

    "wardrobe_searchPlaceholder": "Cerca articoli...",
    "price_basic_weekly": "9,99 €/settimana",
    "price_basic_monthly": "29,99 €/mese",
    "price_basic_quarterly": "79,99 €/trimestre",
    "price_premium_weekly": "19,99 €/settimana",
    "price_premium_monthly": "59,99 €/mese",
    "price_premium_quarterly": "159,99 €/trimestre",
    "price_advanced_weekly": "39,99 €/settimana",
    "price_advanced_monthly": "119,99 €/mese",
    "price_advanced_quarterly": "319,99 €/trimestre",
    "price_nextgen_weekly": "4,99 €/settimana",
    "price_nextgen_monthly": "14,99 €/mese",
    "price_business_workshop_corporate": "5.000 €+",
    "price_style_transformation_essential": "450 €",
    "price_style_transformation_complete": "850 €",
    "price_style_transformation_vip": "1.500 €",
    "loading_updating_item": "Aggiornamento articolo...",
    "loading_updating_pose": "Cambio posa in {{poseName}}...",

    // Capsule Generator
    "capsuleGenerator_title": "Generatore di Armadio Capsula IA",
    "capsuleGenerator_subtitle": "Crea un guardaroba versatile e coeso su misura per il tuo stile e l'occasione.",
    "capsuleGenerator_premium_required": "Questo strumento avanzato di styling IA è disponibile per i nostri membri Premium e Advanced.",
    "capsuleGenerator_select_season": "Seleziona Stagione",
    "capsuleGenerator_select_occasion": "Seleziona Occasione",
    "capsuleGenerator_generate_btn": "Genera Capsula",
    "capsuleGenerator_generating": "Progettando la tua capsula...",
    "capsuleGenerator_season_spring": "Primavera",
    "capsuleGenerator_season_summer": "Estate",
    "capsuleGenerator_season_autumn": "Autunno",
    "capsuleGenerator_season_winter": "Inverno",
    "capsuleGenerator_occasion_work": "Abbigliamento Professionale",
    "capsuleGenerator_occasion_casual": "Weekend Casual",
    "capsuleGenerator_occasion_travel": "Viaggi e Vacanze",
    "capsuleGenerator_occasion_formal": "Eventi Formali",
    "capsuleGenerator_result_palette": "Palette di Colori",
    "capsuleGenerator_result_items": "Pezzi Chiave",
    "capsuleGenerator_result_combinations": "Combinazioni di Outfit",
    "capsuleGenerator_seo_title": "Generatore di Armadio Capsula IA | Constantina Lifestyle",
    "capsuleGenerator_seo_desc": "Genera un guardaroba capsula personalizzato in base alla tua stagione cromatica, al tipo di corpo e alla persona di stile utilizzando l'IA avanzata.",
    "capsuleGenerator_seo_keywords": "guardaroba capsula, stilista IA, pianificazione moda, armadio minimalista, analisi stagione cromatica",

    // Retail Search
    "retailSearchModal_title": "Trova Articoli Simili",
    "retailSearchModal_titleForGarment": "Simile a: {{garmentName}}",
    "retailSearchModal_close": "Chiudi",
    "retailSearchModal_refine_title": "Affina la Ricerca",
    "retailSearchModal_refine_color": "Colore",
    "retailSearchModal_refine_pattern": "Motivo",
    "retailSearchModal_refine_material": "Materiale",
    "retailSearchModal_refine_color_placeholder": "es. Blu Notte",
    "retailSearchModal_refine_pattern_placeholder": "es. A righe",
    "retailSearchModal_refine_material_placeholder": "es. Seta",
    "retailSearchModal_refine_button": "Aggiorna Ricerca",
    "retailSearchModal_loading": "Ricerca tra i rivenditori globali...",
    "retailSearchModal_noResults": "Nessun articolo simile trovato.",
    "retailSearchModal_sources": "Fonti",
    "retailSearchModal_noPreview": "Nessuna Anteprima",
    "loading_updating_background": "Aggiornamento sfondo...",
    "loading_updating_3d": "Generazione vista 3D ({{current}}/4)...",
    "error_update_outfit": "Aggiornamento outfit fallito. {{details}}",
    "error_save_outfit": "Salvataggio outfit fallito. {{details}}",
    "common_user": "Utente",
    "common_back": "Indietro",
    "common_next": "Avanti",
    "canvas_colorPicker_title": "Selettore colore",
    "wardrobe_item_tooltip_locked": "Bloccato: richiede abbonamento {{level}}.",
    "wardrobe_item_tooltip_category": "Categoria: {{category}}",
    "wardrobe_item_tooltip_color": "Colore predefinito: {{color}}",
    "wardrobe_brand_ai_generated": "Generato da IA",
    "wardrobe_item_ai_name_prefix": "IA: {{prompt}}",
    // ... existing translations
    "appName": "Constantina",
    "nav_home": "Home",
    "nav_about": "Chi Siamo",
    "nav_portfolio": "Portfolio",
    "nav_blog": "Blog",
    "nav_services": "Servizi",
    "nav_bookSession": "Prenota Sessione",
    "nav_dressingRoom": "Camerino",
    "nav_myStyles": "I Miei Stili",
    "nav_advisor": "Consulente di Stile",
    "nav_trends": "Tendenze",
    "nav_privacy": "Privacy",
    "nav_terms": "Termini",
    "nav_impressum": "Impressum",
    "nav_startOver": "Ricomincia",
    "nav_save": "Salva",
    "nav_share": "Condividi",
    "nav_findSimilar": "Trova Simili",
    "nav_getStyleTip": "Ottieni Consigli",
    "trend_tag_heritage": "Eredità",
    "trend_tag_sculpted": "Scultoreo",
    "trend_tag_heritage_fusion": "Fusione Eredità",
    "trend_tag_ai_vision": "Visione IA",
    "trend_tag_emerging": "Emergente",
    "trend_tag_alpine_chic": "Chic Alpino",
    "trend_tag_cyber_soft": "Cyber Soft",
    "trend_tag_poet_core": "Poet Core",
    "trend_tag_glamoratti": "Glamoratti",
    "trend_tag_guardian": "Guardian",
    "trend_alpha_cyber_soft_title": "Fusione Pastello Digitale",
    "trend_z_poet_core_title": "Accademico Romantico",
    "trend_millennial_glamoratti_title": "Opulenza Anni '80 Redux",
    "trend_classic_guardian_title": "Eleganza Protettiva",
    "nav_lookbook": "Lookbook",
    "nav_lightMode": "Modalità Chiara",
    "nav_darkMode": "Modalità Scura",
    "nav_switchUser": "Cambia Utente",
    "nav_profile": "Profilo",
    "nav_wardrobe": "Guardaroba",
    "nav_outfit": "Outfit",
    "nav_guestCta": "Accedi per accedere",
    "nav_show_wardrobe": "Mostra Guardaroba",
    "nav_hide_wardrobe": "Nascondi Guardaroba",
    "nav_show_outfit": "Mostra Outfit",
    "nav_hide_outfit": "Nascondi Outfit",
    "nav_signInGoogle": "Accedi con Google",
    "nav_signInFacebook": "Accedi con Facebook",
    "nav_rememberMe": "Ricordami",
    "nav_signUp": "Iscriviti",
    "nav_emailPlaceholder": "Email",
    "nav_passwordPlaceholder": "Password",
    "nav_signUpButton": "Crea Account",
    "nav_continueWith": "O continua con",
    "nav_guestUser": "(Ospite)",
    "nav_proceedToStyling": "Procedi allo Styling",
    "nav_help": "Centro Assistenza",

    "footer_company": "Azienda",
    "footer_legal": "Legale",
    "footer_subscribe_title": "Resta alla Moda",
    "footer_subscribe_desc": "Iscriviti alla nostra newsletter per consigli di stile esclusivi.",
    "footer_subscribe_placeholder": "Inserisci la tua email",
    "footer_subscribe_button_aria": "Iscriviti",
    "footer_subscribe_success": "Grazie per l'iscrizione!",
    "footer_subscribe_error": "Inserisci un indirizzo email valido.",
    "footer_copyright": "Tutti i diritti riservati.",
    "footer_createdBy": "Creato da",

    "portfolio.title": "Portfolio",
    "portfolio.description": "Una selezione dei nostri migliori lavori.",
    "portfolio.searchPlaceholder": "Cerca nel portfolio...",
    "portfolio.noResults.title": "Nessun progetto trovato",
    "portfolio.noResults.message": "Prova con altri termini di ricerca.",
    "portfolio_category_editorial": "Editoriale",
    "portfolio_category_street": "Street Style",
    "portfolio_category_commercial": "Commerciale",
    "portfolio_category_portraits": "Ritratti",
    "portfolio_category_personal": "Personal Styling",
    "portfolio_category_wardrobe": "Guardaroba",
    "portfolio_category_events": "Eventi",
    "portfolio_category_specialty": "Speciale",
    "portfolio.item1.title": "Vogue Urbano",
    "portfolio.item1.desc": "Editoriale City Chic",
    "portfolio.item2.title": "Ritmo della Strada",
    "portfolio.item2.desc": "Moda Street Contemporanea",
    "portfolio.item3.title": "Foschia Estiva",
    "portfolio.item3.desc": "Campagna Commerciale",
    "portfolio.item4.title": "Musa Moderna",
    "portfolio.item4.desc": "Editoriale Alta Moda",
    "portfolio.item5.title": "Essenza Pura",
    "portfolio.item5.desc": "Ritratti a Luce Naturale",

    "socialCarousel_simulation_note": "* Feed social media simulato",

    "portfolioPage_service_personalStyling_title": "Personal Styling",
    "portfolioPage_service_personalStyling_description": "Rinnovamento completo dello stile.",
    "portfolioPage_service_wardrobeCuration_title": "Cura del Guardaroba",
    "portfolioPage_service_wardrobeCuration_description": "Ottimizza il tuo armadio.",
    "portfolioPage_service_eventStyling_title": "Event Styling",
    "portfolioPage_service_eventStyling_description": "Il look perfetto per ogni occasione.",
    "portfolioPage_service_individualShopping_title": "Personal Shopping",
    "portfolioPage_service_individualShopping_description": "Esperienza di shopping curata.",
    "portfolioPage_service_makeupAdvisory_title": "Consulenza Trucco",
    "portfolioPage_service_makeupAdvisory_description": "Bellezza adatta al tuo stile.",
    "portfolioPage_service_colorAnalysis_title": "Analisi del Colore",
    "portfolioPage_service_colorAnalysis_description": "Trova la tua palette perfetta.",
    "portfolioPage_service_premiumInPerson_title": "Premium di Persona",
    "portfolioPage_service_businessWorkshops_title": "Workshop Aziendali",
    "portfolioPage_service_businessWorkshops_description": "Migliora l'immagine professionale del tuo team.",
    "portfolioPage_service_styleTransformation_title": "Trasformazione di Stile",
    "portfolioPage_service_styleTransformation_description": "Una reinvenzione completa del tuo stile personale.",
    "portfolioPage_package_essential": "Essenziale",
    "portfolioPage_package_complete": "Completo",
    "portfolioPage_package_vip": "VIP",

    "styleReport_title": "Rapporto di Stile",
    "styleReport_generatedFor": "Generato per {{username}}",
    "styleReport_date": "Data",
    "styleReport_profile_title": "Profilo di Stile",
    "styleReport_no_persona": "Nessuna persona di stile generata ancora.",
    "styleReport_outfits_title": "Outfit Salvati",
    "styleReport_lookbooks_title": "Lookbooks",
    "styleReport_plans_title": "Piani di Stile",
    "styleReport_no_plans": "Nessun piano di stile salvato.",
    "styleReport_back": "Torna ai Miei Stili",
    "styleReport_print": "Stampa Rapporto",

    "agentWorkflow_title": "Agente di Stile",
    "agentWorkflow_greeting": "Ciao! Sono il tuo Agente di Stile dedicato. Posso aiutarti a trovare articoli, prenotare appuntamenti o creare contenuti social per i tuoi look. Cosa hai in mente?",
    "agentWorkflow_error_noItemsFound": "Non sono riuscito a trovare articoli simili al momento.",
    "agentWorkflow_fallback": "Non ho capito bene. Prova a chiedere 'trova articoli simili' o 'prenota una sessione'.",
    "agentWorkflow_error": "Spiacente, si è verificato un errore.",
    "agentWorkflow_placeholder": "Digita una richiesta...",
    "agentWorkflow_socialMediaSavedTitle": "Contenuto Social Media",

    "trendSpotter.greeting": "Pronto a stare al passo con i tempi? Sono il tuo Trend Spotter. Chiedimi delle ultime novità dalle passerelle, stili street virali o quali colori dominano questa stagione!",
    "trendSpotter.cleared": "Cronologia chat cancellata.",
    "trendSpotter.thinking": "Analisi delle tendenze globali...",
    "trendSpotter.placeholder": "Chiedi sulle tendenze emergenti...",

    "homePage_businessStyling": "Per le Aziende",
    "homePage_cta": "Prova Virtuale",
    "loading_rendering": "Rendering dei dettagli...",
    "loading_generating_model": "Creando il nuovo te...",
    "homePage_bookConsultation": "Prenota Consulenza",
    "homePage_uploadInput_label": "Carica la tua foto",
    "homePage_transformation_title": "Trasformazione",
    "homePage_transformation_desc": "Vedi la differenza.",
    "seo_about_title": "Su Constantina",
    "seo_about_description": "Scopri la nostra missione di democratizzare lo stilismo professionale utilizzando una tecnologia AI avanzata.",
    "seo_about_kw1": "moda AI",
    "seo_about_kw2": "stylist virtuale",
    "seo_about_kw3": "tecnologia di stilismo",
    "seo_about_kw4": "missione fashion tech",
    "aboutPage_socialText": "Rimani aggiornato con le nostre ultime tendenze.",
    "about_usp_title": "Perché Constantina?",
    "about_usp_1_title": "IA Centrata sull'Uomo",
    "about_usp_1_desc": "L'efficienza di AI combinata con l'intuizione di stylist esperti.",
    "about_usp_2_title": "Tendenze Basate sui Dati",
    "about_usp_2_desc": "Analisi in tempo reale delle tendenze globali dalle principali capitali della moda.",
    "about_usp_3_title": "Branding Personale",
    "about_usp_3_desc": "Non ti vestiamo solo; ti aiutiamo a proiettare il tuo io più autentico.",
    "about_usp_4_title": "Portata Globale",
    "about_usp_4_desc": "Styling di alto livello accessibile, ovunque tu sia nel mondo.",
    "about_certification_title": "Le Nostre Certificazioni",
    "about_certification_desc": "Esperienza riconosciuta dalle principali istituzioni della moda.",
    "aboutPage_certified_milano": "Master in Fashion Styling - Milano",
    "aboutPage_certified_london": "Fashion Communication - Londra",
    "booklet_minimalist_title": "La Guida al Guardaroba Minimalista",
    "booklet_minimalist_desc": "Domina l'arte di costruire un guardaroba versatile e di alta qualità con meno pezzi.",
    "booklet_color_theory_title": "Essenziali della Teoria dei Colori",
    "booklet_color_theory_desc": "Scopri la tua palette di colori perfetta e impara a creare outfit armoniosi.",
    "booklet_executive_title": "Styling per la Presenza Esecutiva",
    "booklet_executive_desc": "Guida allo styling professionale per costruire autorità attraverso il tuo guardaroba.",
    "booklet_capsule_title": "Il Piano del Guardaroba Capsule",
    "booklet_capsule_desc": "Guida completa alla creazione di collezioni capsule stagionali che funzionano insieme.",
    "booklet_downloading": "Scaricamento in corso",
    "aboutPage_title": "L'Arte dello Styling incontra l'Intelligenza Artificiale",
    "aboutPage_tagline": "Colmare il divario tra eleganza senza tempo e tecnologia della moda all'avanguardia.",
    "aboutPage_paragraph1": "Fondata nel cuore della Svizzera, Constantina è nata da un'unica visione: democratizzare la consulenza d'immagine più sofisticata al mondo. Crediamo che il vero stile sia più di semplici vestiti—è un asset strategico e una potente forma di espressione di sé, resa accessibile a tutti attraverso la fusione di competenza umana e tecnologia IA avanzata.",
    "aboutPage_paragraph2": "Oggi, la nostra piattaforma funge da concierge di stile personale globale, consentendo alle persone di navigare nella loro presenza professionale e personale con la sicurezza di un maestro sarto, supportata dalla precisione dell'IA generativa.",
    "aboutPage_missionText": "Lo stile è il linguaggio silenzioso dell'identità. La nostra missione è darti gli strumenti per parlarlo correntemente, con assoluta fiducia e impatto strategico, in qualsiasi parte del mondo.",
    "aboutPage_techTitle": "L'Intelligenza dietro l'Arte",
    "aboutPage_techText_p1": "Utilizziamo i modelli multimodali più AI e oltre—per eseguire analisi visive in tempo reale di capi, texture e silhouette.",
    "aboutPage_techText_p2": "Ogni raccomandazione si basa su principi di styling professionale, teoria del colore e contesti storici della moda, assicurando che la nostra IA rimanga uno strumento di elevazione, non solo di automazione.",
    "aboutPage_teamTitle": "I Nostri Visionari",
    "aboutPage_socialTitle": "Connettiti con il Nostro Futuro",
    "author_elara_vance_name": "Constantina",
    "author_elara_vance_bio": "Una veterana delle case di moda milanesi con una profonda passione per l'intersezione tra tecnologia e styling tradizionale.",
    "elara-vance_role": "Direttore Creativo",
    "author_julian_sinclair_name": "Hannes",
    "author_julian_sinclair_bio": "Specializzato in etica dell'IA e pattern di elaborazione visiva, garantendo che il nostro styling rimanga umano e intuitivo.",
    "julian-sinclair_role": "Capo dell'Architettura IA",
    "author_heidi_steiner_name": "Heidi Steiner",
    "author_heidi_steiner_bio": "Mette a disposizione della sfera digitale anni di esperienza come concierge in boutique di alto livello.",
    "heidi-steiner_role": "Chief Concierge",
    "author_lukas_weber_name": "Lukas Weber",
    "author_lukas_weber_bio": "Si concentra sui dati della moda sostenibile e sulla trasparenza dell'approvvigionamento nell'era digitale.",
    "lukas-weber_role": "Sustainability Lead",
    "contact_title": "Mettiamoci in Contatto",
    "contact_subtitle": "Hai domande sul nostro styling IA o vuoi prenotare un workshop personalizzato? Contattaci e ti risponderemo entro 24 ore.",
    "contact_info_title": "Dettagli di Contatto",
    "contact_email_label": "Email",
    "contact_phone_label": "Telefono",
    "contact_office_label": "Ufficio",
    "contact_follow_us": "Seguici",
    "contact_success_title": "Messaggio Inviato!",
    "contact_success_desc": "Grazie per averci contattato. Constantina esaminerà il tuo messaggio e risponderà al più presto.",
    "contact_form_name": "Nome",
    "contact_form_email": "Email",
    "contact_form_subject": "Oggetto",
    "contact_form_message": "Messaggio",
    "contact_form_submit": "Invia Messaggio",
    "contact_form_placeholder_name": "Il tuo nome",
    "contact_form_placeholder_email": "tua@email.com",
    "contact_form_placeholder_subject": "Di cosa si tratta?",
    "contact_form_placeholder_message": "Dicci come possiamo aiutarti...",
    "contact_form_send_another": "Invia un altro messaggio",

    // Portfolio Page
    // Portfolio Page (Merged below)


    stylingAdvisorPage_greeting: "Ciao! Sono il tuo stilista personale AI. Come posso aiutarti a migliorare il tuo look oggi?",
    stylingAdvisorPage_tagline: "Il tuo consulente di moda personale AI.",
    stylingAdvisorPage_chatSection: "Chat",
    stylingAdvisorPage_agentSelectorLabel: "Scegli un Agente",
    stylingAdvisorPage_planSectionTitle: "Piano di Stile",
    stylingAdvisorPage_planSectionDescription: "Genera una roadmap di stile personalizzata basata sulle tue preferenze.",
    stylingAdvisorPage_photoAnalysisSectionTitle: "Analisi del Colore",
    stylingAdvisorPage_photoAnalysisSectionDescription: "Carica una foto per scoprire la tua palette di colori stagionale.",
    stylingAdvisorPage_photoAnalysisButton: "Analizza la mia Foto",
    stylingAdvisorPage_photoAnalysisSelectLabel: "Seleziona da Outfit Salvati",
    stylingAdvisorPage_agentsSectionTitle: "Agenti Automatizzati",
    stylingAdvisorPage_agentsDashboardTitle: "I Miei Agenti di Stile Attivi",
    stylingAdvisorPage_createAgent: "Crea Nuovo Agente",
    stylingAdvisorPage_noAgents: "Non hai ancora creato agenti automatizzati.",
    stylingAdvisorPage_saveSuccess: "Salvato!",
    stylingAdvisorPage_planSavedTitle: "Piano di Stile {{duration}}",
    stylingAdvisorPage_placeholder: "Chiedi consiglio...",
    stylingAdvisorPage_planDuration_weekly: "Settimanale",
    stylingAdvisorPage_planDuration_monthly: "Mensile",
    stylingAdvisorPage_planDuration_quarterly: "Trimestrale",
    stylingAdvisorPage_mandatory_fields_tooltip: "Completa la tua Persona di Stile nel Profilo per sbloccare.",
    stylingAdvisorPage_agent_styleQuestionnaire_name: "Questionario di Stile",
    stylingAdvisorPage_agent_styleQuestionnaire_description: "Scopri la tua persona di stile unica attraverso domande e risposte.",
    stylingAdvisorPage_agent_business_name: "Professionista Business",
    stylingAdvisorPage_agent_business_description: "Consigli per abbigliamento corporate e smart-casual.",
    stylingAdvisorPage_agent_vogueEditor_name: "Editorial Chic",
    stylingAdvisorPage_agent_vogueEditor_description: "Moda alta, audace e di tendenza.",
    stylingAdvisorPage_agent_glamour_name: "Glamour Red Carpet",
    stylingAdvisorPage_agent_glamour_description: "Abbigliamento da sera e styling per occasioni speciali.",
    stylingAdvisorPage_agent_locked_basic: "Piano Base Richiesto",
    stylingAdvisorPage_agent_locked_premium: "Piano Premium Richiesto",
    stylingAdvisorPage_agent_locked_advanced: "Piano Avanzato Richiesto",
    stylingAdvisorPage_planError: "Impossibile generare il piano di stile. Riprova.",
    stylingAdvisorPage_questionnaire_wizard_lifestyle_outdoor: "Quanto tempo passi all'aperto / fuori?",
    "bookingForm_success_message_email": "La tua richiesta di prenotazione è stata inviata. Controlla la tua email per l'invito al calendario.",

    styleBot_questionnaire_intro: "Ciao! Per darti il miglior consiglio, vorrei sapere: 1. Genere 2. Forma del corpo 3. Forma del viso 4. Stagione cromatica 5. Preferenza di stile. Puoi rispondere tutto in una volta o uno per uno!",
    styleBot_chip_female: "Donna",
    styleBot_chip_male: "Uomo",
    styleBot_chip_non_binary: "Non binario",
    styleBot_chip_hourglass: "Corpo a Clessidra",
    styleBot_chip_pear: "Corpo a Pera",
    styleBot_chip_rectangle: "Corpo a Rettangolo",
    styleBot_chip_athletic: "Corporatura Atletica",
    styleBot_chip_oval_face: "Viso Ovale",
    styleBot_chip_square_face: "Viso Quadrato",
    styleBot_chip_round_face: "Viso Tondo",
    styleBot_chip_heart_face: "Viso a Cuore",
    styleBot_chip_winter: "Inverno",
    styleBot_chip_summer: "Estate",
    styleBot_chip_autumn: "Autunno",
    styleBot_chip_spring: "Primavera",
    styleBot_chip_minimalist: "Stile Minimalista",
    styleBot_chip_boho: "Boho Chic",
    styleBot_chip_classic: "Stile Classico",
    styleBot_chip_streetwear: "Streetwear",

    styleAgent_modal_title: "Configura Agente di Stile",
    styleAgent_modal_desc: "Imposta un agente automatizzato per scovare tendenze e pianificare outfit per te in background.",
    styleAgent_name_label: "Nome Agente",
    styleAgent_name_placeholder: "es., Scout Vacanze Estive",
    styleAgent_frequency_label: "Frequenza",
    styleAgent_season_label: "Stagione Target",
    styleAgent_focus_label: "Focus Stile",
    styleAgent_create_btn: "Attiva Agente",
    styleAgent_freq_weekly: "Settimanale",
    styleAgent_freq_monthly: "Mensile",

    "voucher_modal_title": "Acquista Buono Regalo",
    "voucher_modal_success_title": "Buono Creato!",
    "voucher_modal_success_message": "Il tuo buono è stato creato con successo. Puoi copiare il codice qui sotto.",
    "voucher_modal_service_label": "Seleziona Servizi",
    "voucher_modal_recipient_name_label": "Nome destinatario",
    "voucher_modal_recipient_name_placeholder": "es. Maria Rossi",
    "voucher_modal_recipient_email_label": "Email destinatario",
    "voucher_modal_recipient_email_placeholder": "maria@esempio.com",
    "voucher_modal_message_label": "Messaggio Personale",
    "voucher_modal_message_placeholder": "Scrivi una nota...",
    "voucher_modal_purchase_button": "Acquista Buono",
    "voucher_modal_purchasing": "Elaborazione...",
    "voucher_modal_copy_code": "Copia Codice",

    myStylesPage_title: 'I Miei Stili',
    myStylesPage_empty_title: "Nessuno stile ancora",
    myStylesPage_empty_desc: "Crea outfit nel Camerino per vederli qui.",
    myStylesPage_tab_outfits: "Outfit Salvati",
    myStylesPage_tab_items: "Articoli Guardaroba",
    myStylesPage_delete_confirm: "Sei sicuro di voler eliminare questo stile?",
    myStylesPage_created_at: "Creato il",

    // Booking Page


    // Blog Page
    "blogPage_title": "Diario di Stile",
    "blogPage_tagline": "Approfondimenti, tendenze e consigli degli esperti.",
    "blogPage_resources_title": "Risorse Esclusive",
    "blogPage_resources_locked_msg": "Passa a Premium per accedere alle nostre guide di stile.",
    "blogPage_resources_upgrade": "Aggiorna Ora",
    "blog_post_read_more": "Leggi di Più",
    "editorial_rss_title": "Notizie del Settore",
    "editorial_rss_subtitle": "Feed curati dalle migliori pubblicazioni di moda.",

    // Canvas / Dressing Room
    "canvas_seo_title": "Camerino Virtuale - Constantina",
    "canvas_seo_desc": "Prova gli outfit virtualmente con la nostra tecnologia AI. Il tuo stylist personale.",
    "canvas_seo_keywords": "Camerino Virtuale IA, Stylist Personale, Guardaroba Digitale, Fashion Tech, Creatore Outfit",
    "canvas_uploadToStart": "Carica una foto per iniziare",
    "canvas_view3D": "Visualizza in 3D",
    "canvas_shopTheLook": "Acquista il Look",
    "canvas_favorite_add": "Aggiungi ai Preferiti",
    "canvas_favorite_remove": "Rimuovi dai Preferiti",
    "sceneControl_title": "Controlli Scena",
    "sceneControl_background_label": "Sfondo",
    "sceneControl_custom_bg_placeholder": "Descrivi uno sfondo...",
    "sceneControl_modelScale_label": "Scala Modello",
    "sceneControl_bg_studio": "Studio",
    "sceneControl_bg_street": "Strada",
    "sceneControl_bg_nature": "Natura",
    "sceneControl_bg_cafe": "Caffè",
    "sceneControl_bg_beach": "Spiaggia",
    "aboutPage_contactUs": "Contattaci",
    "legalPage_title": "Informazioni Legali",
    "legalPage_tagline": "Termini, privacy e informazioni legali importanti sui nostri servizi.",
    "seo_legal_title": "Informazioni Legali - Termini e Privacy",
    "seo_legal_description": "Leggi i nostri termini di servizio, politica sulla privacy, politica sui cookie e note legali.",
    "seo_legal_kw1": "termini di servizio",
    "seo_legal_kw2": "politica sulla privacy",
    "seo_legal_kw3": "informazioni legali",
    "seo_legal_kw4": "note legali",
    "legalPage_impressum_title": "Note Legali",
    "legalPage_terms_title": "Termini e Condizioni",
    "legalPage_privacy_title": "Politica sulla Privacy",
    "legalPage_cookies_title": "Politica sui Cookie",
    "portfolioPage_services_title": "I Nostri Servizi",
    "portfolioPage_all_categories": "Tutte le Categorie",
    "portfolioPage_bookService": "Prenota Servizio",
    "membership_cycle_weekly": "Settimanale",
    "membership_cycle_monthly": "Mensile",
    "membership_cycle_quarterly": "Trimestrale",
    "membership_subscribe_button": "Abbonati Ora",
    "membership_cycle_free": "Gratis",
    "profilePage_membership_free": "Gratis",
    "membership_feature_free_1": "Scoperta dello stile standard",
    "membership_feature_free_2": "Feed di stile curato",
    "membership_feature_basic_1": "Accesso Standard",
    "membership_feature_basic_2": "Guardaroba Base",
    "membership_feature_basic_3": "Prove Limitate",
    "membership_feature_basic_4": "Supporto Community",
    "membership_feature_premium_1": "Accesso Prioritario",
    "membership_feature_premium_2": "Guardaroba Illimitato",
    "membership_feature_premium_3": "Prove Illimitate",
    "membership_feature_premium_4": "Supporto Email",
    "membership_feature_premium_5": "Contenuto Esclusivo",
    "membership_feature_premium_style_tips": "Consigli di Stile AI",
    "membership_feature_advanced_1": "Tutte le funzioni Premium",
    "membership_feature_advanced_2": "Consulenza 1-a-1",
    "membership_feature_advanced_3": "Accesso Anticipato",
    "membership_feature_advanced_4": "Supporto VIP",
    "membership_feature_advanced_5": "Personal Shopper",
    "membership_feature_advanced_social_media": "Gen Contenuti Social",
    "membership_feature_advanced_plan_integration": "Integrazione Piano Stile",
    "membership_feature_advanced_automated_shopping": "Shopping Automatizzato",
    "membership_feature_nextgen_1": "Eco-Style Insights",
    "membership_feature_nextgen_2": "Avvisi Tendenze Social",
    "membership_feature_nextgen_3": "Guide Thrifting Curate",
    "membership_feature_nextgen_4": "Integrazione Tendenze TikTok",
    "portfolio_feature_1hr_video_call": "Videochiamata di 1 ora",
    "portfolio_feature_style_questionnaire": "Questionario di Stile",
    "portfolio_feature_personalized_mood_board": "Mood Board Personalizzato",
    "portfolio_feature_all_online_features": "Tutte le funzioni online",
    "portfolio_feature_virtual_try_on_session": "Sessione di Prova Virtuale",
    "portfolio_feature_ai_lookbook": "Lookbook AI",
    "portfolio_feature_retail_search": "Ricerca Retail",
    "portfolio_feature_all_ai_features": "Tutte le funzioni AI",
    "portfolio_feature_in_person_consultation": "Consulenza di persona",
    "portfolio_feature_hands_on_styling": "Styling pratico",
    "portfolio_feature_wardrobe_analysis": "Analisi del guardaroba",
    "portfolio_feature_declutter_guide": "Guida al decluttering",
    "portfolio_feature_shopping_list": "Lista della spesa",
    "portfolio_feature_ai_outfit_pairing": "Abbinamento Outfit AI",
    "portfolio_feature_seasonal_capsule": "Capsule stagionale",
    "portfolio_feature_event_consultation": "Consulenza per eventi",
    "portfolio_feature_3_outfit_proposals": "3 proposte di outfit",
    "portfolio_feature_accessorizing_guide": "Guida agli accessori",
    "portfolio_feature_event_virtual_try_on": "Prova virtuale per eventi",
    "portfolio_feature_pose_variation_check": "Controllo variazioni posa",
    "portfolio_feature_shopping_consultation": "Consulenza shopping",
    "portfolio_feature_curated_shopping_list": "Lista shopping curata",
    "portfolio_feature_style_integration_session": "Sessione di integrazione",
    "portfolio_feature_ai_product_search": "Ricerca prodotto AI",
    "portfolio_feature_vto_shortlist": "Shortlist VTO",
    "portfolio_feature_makeup_video_call": "Videochiamata trucco",
    "portfolio_feature_product_recommendations": "Raccomandazioni prodotti",
    "portfolio_feature_technique_guide": "Guida alle tecniche",
    "portfolio_feature_ai_face_analysis": "Analisi facciale AI",
    "portfolio_feature_virtual_makeup_try_on": "Prova trucco virtuale",
    "portfolio_feature_color_consultation": "Consulenza colore",
    "portfolio_feature_digital_palette": "Palette digitale",
    "portfolio_feature_outfit_color_guide": "Guida colore outfit",
    "portfolio_feature_ai_color_detection": "Rilevamento colore AI",
    "portfolio_feature_interactive_palette": "Palette interattiva",
    "portfolio_feature_team_style_guide": "Guida stile team",
    "portfolio_feature_brand_identity_alignment": "Allineamento brand identity",
    "portfolio_feature_group_qa": "Domande e risposte di gruppo",
    "portfolio_feature_executive_presence": "Presenza esecutiva",
    "portfolio_feature_personal_shopping_day": "Giorno di personal shopping",
    "portfolio_feature_keynote_speech": "Discorso di apertura",
    "portfolio_feature_pop_up_styling": "Pop-up Styling Bar",
    "portfolio_feature_wardrobe_edit": "Edit del Guardaroba",
    "portfolio_feature_style_guide": "Guida di Stile",
    "portfolio_feature_personal_shopping": "Personal Shopping",
    "portfolio_feature_makeup_lesson": "Lezione di Trucco",
    "portfolio_feature_follow_up": "Sessione di Follow-up",
    "portfolio_feature_photoshoot": "Servizio Fotografico Professionale",
    "portfolio_feature_hair_consultation": "Consulenza Capelli",
    "portfolio_feature_vip_concierge": "Concierge VIP",

    "nav_user_status_current": "Attuale",
    "nav_user_status_active": "Sessione attiva",
    "nav_user_action_login": "Accedi",
    "nav_user_action_delete": "Elimina utente",
    "nav_admin_model_config": "Admin: Configurazione modello",
    "nav_admin_gen_model": "Modello di generazione immagine",
    "nav_admin_gen_model_desc": "Seleziona il modello AI da utilizzare per la generazione.",
    "nav_admin_model_flash": "Gemini 1.5 Flash (Predefinito)",
    "nav_admin_model_pro": "Gemini 1.5 Pro (Alta qualità)",
    "nav_membership_recommended": "CONSIGLIATO",
    "membership_most_popular": "Più popolare",
    "nav_app_download_prefix_ios": "Scarica su",
    "nav_app_store_ios": "App Store",
    "nav_app_download_prefix_android": "DISPONIBILE SU",
    "nav_app_store_android": "Google Play",

    "home_hero_title": "Domina il tuo stile personale con la precisione dell'IA",
    "home_hero_title_new": "Eleva la tua presenza. Non chiederti mai più cosa indossare.",
    "home_hero_subtitle": "Il tuo concierge di moda professionale AI. Scopri look curati su misura per la tua palette unica, la forma del corpo e la voce del tuo brand personale.",
    "home_hero_cta": "Inizia la sessione di styling",
    "home_seo_title": "Constantina - Camerino virtuale IA & Stylist personale",
    "home_seo_desc": "Rivoluziona la tua esperienza di acquisto con il nostro camerino virtuale IA. Prova i vestiti istantaneamente.",
    "home_seo_keywords": "Camerino Virtuale IA, Stylist Personale, Guardaroba Digitale, Fashion Tech, Creatore Outfit",
    "home_empathy_title": "Lo stile è personale. Lo capiamo.",
    "home_empathy_desc": "Crediamo che la moda debba dare forza, non intimidire. La nostra IA impara le tue preferenze uniche, il tuo corpo e il tuo stile di vita per offrirti consigli che ti rappresentano davvero — non un algoritmo che insegue le tendenze.",
    "home_press_title": "Come visto su",

    "profile_seo_title": "Il mio Profilo - Constantina",
    "profile_seo_desc": "Gestisci la tua persona di stile, l'abbonamento e le impostazioni dell'account su Constantina.",
    "profile_seo_keywords": "profilo utente, persona di stile, impostazioni account, Constantina",
    "profilePage_measurements_colorSeason_label": "Profilo colore (Stagione)",
    "profilePage_measurements_ai_auto_detect": "Auto-rilevamento IA",
    "profilePage_stylePersona_analyzing_dna": "Analisi del tuo DNA di stile...",

    "rss_source_vogue": "Vogue",
    "rss_source_elle": "Elle",
    "rss_source_harpers": "Harper's Bazaar",
    "rss_source_fashionista": "Fashionista",
    "rss_source_bof": "Business of Fashion",
    "rss_source_journelles": "Journelles",
    "rss_source_highsnobiety": "Highsnobiety",
    "rss_source_instyle": "InStyle",
    "rss_source_glamour": "Glamour",
    "rss_source_beige": "Beige",
    "rss_source_refinery29": "Refinery29",
    "rss_source_grazia": "Grazia",
    "rss_source_originalcopy": "The Original Copy",
    "rss_source_modepilot": "Modepilot",
    "rss_source_fashionunited": "FashionUnited",
    "rss_source_jolie": "Jolie",
    "rss_source_cosmopolitan": "Cosmopolitan",
    "rss_source_mashasedgwick": "Masha Sedgwick",
    "rss_source_ohhcouture": "Ohh Couture",
    "rss_source_carodaur": "Caro Daur",
    "rss_source_novalanalove": "Novalanalove",
    "payment_modal_select_method": "Seleziona Metodo di Pagamento",
    "payment_method_card": "Carta di Credito / Debito",
    "payment_method_paypal": "PayPal",
    "payment_method_twint": "TWINT (Svizzera)",
    "payment_method_sofort": "Sofort / Klarna (Germania)",
    "payment_continue_to": "Continua con {{method}}",
    "nav_logout": "Disconnettersi",
    "generation_alpha": "Gen Alpha",
    "generation_z": "Gen Z",
    "generation_millennial": "Millennials",
    "generation_classic": "Classico / Boomers",
    "trend_alpha_digital_twin_title": "Sincronizzazione Digital Twin",
    "trend_alpha_gaming_couture_title": "Couture Meta-Gaming",
    "trend_z_y2k_redux_title": "Estetica Y2K Redux",
    "trend_z_thrifting_elite_title": "Curazioni Second Hand",
    "trend_millennial_80s_glam_title": "80s Power Glam",
    "trend_millennial_quiet_luxury_title": "Quiet Luxury",
    "trend_classic_heritage_title": "Heritage Outdoors",
    "trend_tag_ai_native": "IA Nativa",
    "trend_tag_metaverse": "Metaverso",
    "trend_tag_nostalgia": "Nostalgia",
    "trend_tag_eco_conscious": "Eco-Elite",
    "trend_tag_sophisticated": "Sofisticato",
    "trend_tag_timeless": "Senza Tempo",
    "portfolio.alpha.title": "Identità Digitali Gen Alpha",
    "portfolio.alpha.desc": "Unire skin virtuali ad armadi di lusso fisici per la prima generazione nativa digitale.",
    "portfolio.z.title": "Individualità Gen Z",
    "portfolio.z.desc": "Second hand potenziato dall'IA e trend spotting sociale per i trend-setter.",
    "portfolio.millennial.title": "Picco di Carriera Millennial",
    "portfolio.millennial.desc": "Glamour anni '80 elevato e lusso discreto senza tempo per il professionista moderno.",
    "trends_seo_title": "Tendenze Moda 2026 | Constantina",
    "trends_seo_desc": "Esplora le ultime tendenze moda Gen Z e globali. Rimani all'avanguardia con insights potenziati dall'IA.",
    "trends_seo_keywords": "tendenze moda, stile gen z, moda 2026, trend spotting, moda sostenibile",

    // Wardrobe & Outfit Stack (New)
    "wardrobe_category_Tops": "Top",
    "wardrobe_category_Jackets": "Giacche e Cappotti",
    "wardrobe_category_Outerwear": "Capispalla",
    "wardrobe_category_Dresses": "Abiti",
    "wardrobe_category_Bottoms": "Pantaloni e Gonne",
    "wardrobe_category_Shoes": "Scarpe",
    "wardrobe_category_Bags": "Borse",
    "wardrobe_category_Eyewear": "Occhiali",
    "wardrobe_category_Jewelry": "Gioielli",
    "wardrobe_category_Other": "Accessori e Altro",
    "wardrobe_category_All": "Tutte le Categorie",

    "lifeSphere_selection_title": "Il tuo focus attuale",
    "lifeSphere_selection_desc": "Seleziona la tua Life Sphere attiva per personalizzare i consigli.",
    "lifeSphere_executive_title": "Ascesa Esecutiva",
    "lifeSphere_executive_desc": "Presenza professionale elevata e power dressing.",
    "lifeSphere_romantic_title": "Rinascimento Romantico",
    "lifeSphere_romantic_desc": "Styling seducente e sicuro per la tua vita amorosa.",
    "lifeSphere_matriarch_title": "Matriarca senza sforzo",
    "lifeSphere_matriarch_desc": "Eleganza chic e funzionale per la vita familiare.",
    "lifeSphere_creative_title": "Fioritura Creativa",
    "lifeSphere_creative_desc": "Silhouette audaci che riflettono la crescita artistica.",
    "wardrobe_tab_garments": "Capi",
    "wardrobe_tab_accessories": "Accessori",
    "wardrobe_tab_sets": "Set Curati",
    "wardrobe_upload_garment_title": "Aggiungi Capo",
    "wardrobe_upload_accessory_title": "Aggiungi Accessorio",
    "wardrobe_upload_garment": "Carica",
    "wardrobe_upload_accessory": "Carica",

    "outfitStack_title": "Composizione Outfit",
    "outfitStack_undo": "Annulla",
    "outfitStack_redo": "Ripristina",
    "outfitStack_empty_prompt": "Seleziona articoli dal guardaroba per iniziare.",
    "outfitStack_changeColor_aria": "Cambia colore per {{itemName}}",
    "outfitStack_adjust_aria": "Regola {{itemName}}",
    "outfitStack_remove_aria": "Rimuovi {{itemName}}",
    "outfitStack_findSimilar_aria": "Trova simili a {{itemName}}",
    "outfitStack_findSimilar_main": "Acquista Simili",
    "outfitStack_addToLookbook": "Aggiungi al Lookbook",
    "outfitStack_suggestVariations": "Suggerisci Variazioni",
    "outfitStack_analyzeColor": "Analizza Palette",
    "outfitStack_creativeTools": "Strumenti Creativi",
    "outfitStack_saveOutfitFirstForLookbook": "Salva prima l'outfit per aggiungerlo al lookbook",
    "alert_selectGarmentFirst": "Seleziona prima un capo principale.",

    // Client Stories
    "testimonialsPage_title": "Storie dei Clienti",
    "testimonialsPage_tagline": "Ascolta la nostra community globale di appassionati di stile.",
    "testimonialsPage_workInAction_title": "Lavoro in Azione",
    "testimonialsPage_workInAction_tagline": "Risultati reali dalle nostre sessioni di styling e strumenti.",
    "testimonialsPage_workInAction_connectButton": "Collega Social",
    "testimonialsPage_workInAction_connecting": "Connessione...",
    "testimonialsPage_workInAction_youtubeTitle": "Trasformazioni YouTube",
    "testimonialsPage_workInAction_instagramTitle": "Reels Instagram",
    "testimonialsPage_workInAction_twitterTitle": "Tweet di Stile",
    "threeSixty_dragToRotate": "Trascina per ruotare",

    // Testimonials
    "testimonial_name_1": "Sophie M.",
    "testimonial_location_paris": "Parigi, Francia",
    "testimonial_quote_1": "Constantina ha trasformato il mio guardaroba. Finalmente so quali colori mi fanno brillare!",
    "testimonial_name_2": "Alessandro R.",
    "testimonial_location_milan": "Milano, Italia",
    "testimonial_quote_2": "La sessione di styling di persona è stata una svolta per la mia immagine professionale.",
    "testimonial_name_3": "Emma W.",
    "testimonial_location_london": "Londra, Regno Unito",
    "testimonial_quote_3": "Riordinare il mio armadio con gli strumenti AI ha reso il decluttering divertente ed efficace.",
    "testimonial_name_4": "Wei L.",
    "testimonial_location_shanghai": "Shanghai, Cina",
    "testimonial_quote_4": "Ho usato il servizio di styling per eventi. I consigli sull'outfit erano perfetti.",
    "testimonial_name_5": "Kenji T.",
    "testimonial_location_tokyo": "Tokyo, Giappone",
    "testimonial_quote_5": "La funzione Style Persona ha catturato la mia estetica meglio di quanto potessi descrivere.",
    "testimonial_name_6": "Claire D.",
    "testimonial_location_montreal": "Montreal, Canada",
    "testimonial_quote_6": "La prova virtuale mi ha fatto risparmiare un sacco di tempo. Consigliatissimo!",
    "testimonial_name_7": "Elena G.",
    "testimonial_location_barcelona": "Barcellona, Spagna",
    "testimonial_quote_7": "Adoro i piani di stile settimanali. Toglie lo stress di vestirsi per il lavoro.",
    "testimonial_name_8": "Omar K.",
    "testimonial_location_dubai": "Dubai, EAU",
    "testimonial_quote_8": "Trovare articoli simili dalle foto è magia. Ho trovato una giacca che cercavo da mesi.",

    // Social Content
    "reel_1_caption": "Vibrazioni estive con la nostra nuova collezione in lino! ☀️ #summerstyle",
    "reel_2_caption": "Pronta per la stagione di gala. ✨ #eveningwear #glamour",
    "reel_3_caption": "Ispirazione street style da Tokyo. 🇯🇵 #streetwear",
    "youtube_1_title": "10 Essenziali del Guardaroba",
    "youtube_1_published": "2 giorni fa",
    "youtube_2_title": "Come abbinare i Blazer Oversize",
    "youtube_2_published": "1 settimana fa",
    "tweet_1_author": "Fashion Weekly",
    "tweet_1_text": "Il ritorno dell'estetica anni '90 è qui per restare. Qual è il tuo pezzo retrò preferito? 🧥",
    "tweet_1_timestamp": "2h fa",
    "tweet_2_author": "Style Scout",
    "tweet_2_text": "Ho appena visto la nuova collezione Constantina. Assolutamente fuoco! 🔥",
    "tweet_2_timestamp": "5h fa",

    // Lookbook & Social
    "lookbookCreatorModal_aspectRatio": "Rapporto d'Aspetto",
    "lookbookCreatorModal_socialLayout": "Layout Social (stile Influencer)",
    "lookbookCreatorModal_socialLayoutDesc": "Ottimizzato per Instagram Stories e TikTok.",
    "lookbookCreatorModal_socialCaption": "Didascalia Social IA",
    "lookbookCreatorModal_captionPlaceholder": "La didascalia generata dall'IA apparirà qui...",
    "lookbookCreatorModal_download": "Scarica Immagine",
    "lookbookCreatorModal_error_enterName": "Per favore, inserisci un nome per il tuo lookbook.",

    // Profile Page
    "profilePage_measurements_title": "Misure e Attributi",
    "profilePage_measurements_description": "Mantieni i tuoi dettagli aggiornati per migliori raccomandazioni di vestibilità.",
    "profilePage_personalDetails_title": "Dettagli Personali",
    "profilePage_measurements_height": "Altezza",
    "profilePage_measurements_weight": "Peso",
    "profilePage_measurements_chest": "Torace",
    "profilePage_measurements_waist": "Vita",
    "profilePage_measurements_hips": "Fianchi",
    "profilePage_measurements_height_placeholder": "cm/ft",
    "profilePage_measurements_weight_placeholder": "kg/lbs",
    "profilePage_measurements_chest_placeholder": "cm/in",
    "profilePage_measurements_waist_placeholder": "cm/in",
    "profilePage_measurements_hips_placeholder": "cm/in",
    "profilePage_measurements_shoeSize": "Numero di Scarpe",
    "profilePage_measurements_shoeSize_placeholder": "es. 42 / 9",
    "profilePage_attributes_detected_title": "Attributi Rilevati",
    "profilePage_attributes_bodySize": "Corporatura",
    "profilePage_attributes_hairColor": "Colore dei Capelli",
    "profilePage_attributes_eyeColor": "Colore degli Occhi",
    "profilePage_attributes_faceShape": "Forma del Viso",
    "profilePage_attributes_notDetected": "Non rilevato",
    "profilePage_preferredRetailers_label": "Rivenditori Preferiti",
    "profilePage_preferredRetailers_description": "Seleziona i marchi che ami per migliori raccomandazioni.",
    "profilePage_membership_title": "Abbonamento",
    "profilePage_membership_tagline": "Gestisci il tuo piano di abbonamento.",
    "profilePage_membership_level": "Piano Attuale",
    "profilePage_membership_expiry_date": "Data di Scadenza",
    "profilePage_membership_status_basic": "Base",
    "profilePage_membership_status_active": "{{level}} - Attivo fino al {{date}}",
    "profilePage_membership_status_active_no_date": "{{level}} - Attivo",
    "profilePage_membership_status_expired": "{{level}} - Scaduto il {{date}}",
    "profilePage_membership_basic": "Base",
    "profilePage_membership_premium": "Premium",
    "profilePage_membership_advanced": "Avanzato",
    "profilePage_membership_nextgen": "Accesso NextGen",
    "profilePage_membership_current": "Piano Attuale",
    "profilePage_membership_change_hint": "Modificabile solo tramite pagamento di upgrade",
    "profilePage_membership_upgrade": "Aggiorna",
    "profilePage_membership_label": "Abbonamento",
    "profilePage_membership_month": "mese",
    "profilePage_membership_current_label": "Piano Attuale",
    "profilePage_membership_upgrade_button": "Aggiorna",
    "blogPage_resources_locked_title": "Sblocca Contenuto Premium",
    "portfolioPage_title": "Stylist IA Premium & Personal Branding",
    "portfolioPage_tagline": "Migliora la tua immagine professionale con i nostri pacchetti di styling personalizzati e soluzioni di branding esecutivo.",
    "profilePage_mobileApp_title": "Porta il tuo stile ovunque",
    "profilePage_mobileApp_description": "Come membro premium, hai accesso esclusivo alla nostra app mobile. Gestisci il tuo guardaroba, ricevi briefing quotidiani e usa la Style Sandbox ovunque tu sia.",
    "profilePage_mobileApp_qrTitle": "Scansiona per scaricare",
    "travelPage_seo_title": "Lista Bagagli per Viaggi di Lusso e Resort Wear",
    "travelPage_seo_desc": "Cura l'ultima lista bagagli per viaggi di lusso. Dai vestiti per il resort agli elementi essenziali per un city break, pianifica la tua fuga con raccomandazioni fornite dall'IA.",
    "travelPage_seo_keywords": "lista bagagli lusso, moda viaggio, abbigliamento vacanze, guardaroba chic, essenziali viaggio, stilista IA",
    "travelPage_diaries_title": "Diari di Viaggio",
    "travelPage_no_lookbooks": "Nessun lookbook di viaggio trovato.",
    "travelPage_destination_label": "Dove vai?",
    "travelPage_destination_placeholder": "es. Parigi, Tulum, Aspen",
    "travelPage_style_summer": "Estate / Spiaggia",
    "travelPage_style_winter": "Inverno / Sci",
    "travelPage_generating": "Curando il guardaroba...",
    "travelPage_generate_btn": "Genera lista bagaglio",
    "travelPage_result_title": "La tua Capsule per {{destination}}",
    "travelPage_save_diary": "Salva nel diario",
    "travelPage_export_pdf": "Esporta PDF",
    "capsuleGenerator_empty_state": "Seleziona le tue preferenze e clicca su \"Genera\" per vedere la tua capsule personale.",
    "auth_coupon_placeholder": "Codice coupon (opzionale)",
    "user_status_registered": "Registrato",
    "user_status_validated": "In attesa di approvazione",
    "user_status_active": "Attivo",
    "user_status_inactive": "Inattivo",
    "user_status_deleted": "Eliminato",
    "auth_pending_admin": "Account in attesa di approvazione da parte dell'amministratore",
    "auth_pending_confirmation": "Per favore, conferma il tuo indirizzo email.",
    "auth_account_deactivated": "Questo account è stato disattivato.",

    // Style Discovery Wizard
    "stylingAdvisorPage_questionnaire_wizard_title": "Assistente alla Scoperta dello Stile",
    "stylingAdvisorPage_questionnaire_wizard_success": "La tua persona di stile è stata scoperta!",
    "stylingAdvisorPage_questionnaire_wizard_step_evolution": "Quale fase di sviluppo interiore stai riflettendo attualmente?",
    "stylingAdvisorPage_questionnaire_wizard_phase_emergence": "Emersione",
    "stylingAdvisorPage_questionnaire_wizard_phase_leadership": "Leadership",
    "stylingAdvisorPage_questionnaire_wizard_phase_reclamation": "Reclamazione",
    "stylingAdvisorPage_questionnaire_wizard_phase_transition": "Transizione",
    "stylingAdvisorPage_questionnaire_wizard_phase_mastery": "Padronanza",
    "stylingAdvisorPage_questionnaire_wizard_step_archetype": "Qual è il tuo archetipo di stile attuale?",
    "stylingAdvisorPage_questionnaire_wizard_arch_muse": "Musa",
    "stylingAdvisorPage_questionnaire_wizard_arch_warrior": "Guerriero",
    "stylingAdvisorPage_questionnaire_wizard_arch_creator": "Creatore",
    "stylingAdvisorPage_questionnaire_wizard_arch_healer": "Guaritore",
    "stylingAdvisorPage_questionnaire_wizard_arch_ruler": "Sovrano",
    "stylingAdvisorPage_questionnaire_wizard_arch_magician": "Mago",
    "stylingAdvisorPage_questionnaire_wizard_step_generation": "A quale generazione appartieni?",
    "stylingAdvisorPage_questionnaire_wizard_gen_alpha": "Gen Alpha",
    "stylingAdvisorPage_questionnaire_wizard_gen_z": "Gen Z",
    "stylingAdvisorPage_questionnaire_wizard_gen_millennial": "Millennial",
    "stylingAdvisorPage_questionnaire_wizard_gen_x": "Gen X",
    "stylingAdvisorPage_questionnaire_wizard_gen_boomer": "Boomer",
    "stylingAdvisorPage_questionnaire_wizard_gen_classic": "Classico",
    "stylingAdvisorPage_questionnaire_wizard_step_lifestyle": "Raccontaci il tuo stile di vita",
    "stylingAdvisorPage_questionnaire_wizard_lifestyle_office": "Quanto tempo passi in ufficio?",
    "stylingAdvisorPage_questionnaire_wizard_lifestyle_travel": "Quanto viaggi?",
    "stylingAdvisorPage_questionnaire_wizard_intensity_none": "Nessuna",
    "stylingAdvisorPage_questionnaire_wizard_intensity_low": "Bassa",
    "stylingAdvisorPage_questionnaire_wizard_intensity_medium": "Media",
    "stylingAdvisorPage_questionnaire_wizard_intensity_high": "Alta",
    "stylingAdvisorPage_questionnaire_wizard_step_persona": "Seleziona la tua persona di stile",
    "stylingAdvisorPage_questionnaire_wizard_finish": "Scopri il mio stile",
    "homePage_solveStyleProblem_link": "Risolvere un problema di stile",
    "homePage_bookSession_link": "Prenota una sessione",
    "homePage_forCompanies_link": "Per le aziende",
    "stylingAdvisorPage_questionnaire_wizard_persona_minimalist": "Minimalista",
    "stylingAdvisorPage_questionnaire_wizard_persona_bohoChic": "Boho Chic",
    "stylingAdvisorPage_questionnaire_wizard_persona_classicProfessional": "Classico Professionale",
    "stylingAdvisorPage_questionnaire_wizard_persona_streetwear": "Streetwear",
    "stylingAdvisorPage_questionnaire_wizard_persona_avantGarde": "Avanguardia",
    "stylingAdvisorPage_questionnaire_wizard_persona_vintageRetro": "Vintage Retrò",
    "stylingAdvisorPage_questionnaire_wizard_persona_activewear": "Abbigliamento Sportivo",
    "stylingAdvisorPage_questionnaire_wizard_persona_glamorous": "Glamour"
  }
};
